export const addbranch = `
mutation CreateBranch($input: BranchInput!) {
  createBranch(input: $input) {
    success
    error
    message
  }
}
`
export const updatebranch =`
mutation UpdateBranch($id: Int!, $input: BranchInput!) {
  updateBranch(id: $id, input: $input) {
    success
    error
    message
  }
}

`
export const deletebranch = `
mutation DeleteBranch($id: ID!) {
  deleteBranch(id: $id) {
    success
    error
    message
  }
}


`

export const verifyifsc = `
mutation VerifyIFSC($ifscCode: String!) {
  checkIfscCode(ifscCode: $ifscCode) {
    success
    error
    message
    data
  }
}

`